import { render } from "./VideoGridItem.vue?vue&type=template&id=19fbb816&scoped=true"
import script from "./VideoGridItem.vue?vue&type=script&lang=js"
export * from "./VideoGridItem.vue?vue&type=script&lang=js"

import "./VideoGridItem.vue?vue&type=style&index=0&id=19fbb816&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19fbb816"

export default script